import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import axios from "axios";
import ReactMarkdown from "react-markdown";
import BlogPostLayout from "./BlogPostLayout";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DynamicBlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let alive = true;
    setPost(null);
    setNotFound(false);
    axios
      .get(`${API}/blog/posts/${slug}`)
      .then((res) => {
        if (alive) setPost(res.data);
      })
      .catch(() => {
        if (alive) setNotFound(true);
      });
    return () => {
      alive = false;
    };
  }, [slug]);

  if (notFound) return <Navigate to="/conseils" replace />;
  if (!post) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[#5C705E]">
        Chargement…
      </div>
    );
  }

  // Map API shape to BlogPostLayout's expected `post`
  const layoutPost = {
    slug: post.slug,
    title: post.title,
    excerpt: post.excerpt,
    date: post.created_at ? post.created_at.slice(0, 10) : new Date().toISOString().slice(0, 10),
    readMin: post.read_min,
    category: post.category,
    image: post.image,
    keywords: post.keywords,
  };

  return (
    <BlogPostLayout post={layoutPost}>
      <ReactMarkdown
        components={{
          a: ({ href, children, ...props }) => (
            <a href={href} target={href?.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer" {...props}>
              {children}
            </a>
          ),
        }}
      >
        {post.body || ""}
      </ReactMarkdown>
    </BlogPostLayout>
  );
}
